import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiRefreshCcw } from 'react-icons/fi';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from 'react-icons/md';
import ReactTooltip from "react-tooltip";
import api from '~/services/api';
import './styles.css';

// Contexts
import { GeneralContext, ModalContext } from '~/contexts';
import { UnitsContext } from '~/contexts/forms/units';

// Components
import Admin from '~/components/Admin';
import { LoadingSingle } from '~/components/Default/Loading';
import UnitsBox from '~/components/Boxs/AdminUnits';

// Forms
import FormUnit from './Form/Unit';
import FormEnergies from './Form/Energies';
import FormPrices from './Form/Prices';
import FormOthersValues from './Form/OthersValues';
import FormTeAcl from './Form/TeACL';
import InfoMeasurement from './Form/InfoMeasurement';

const AdminUnits: React.FC<any> = () => {
    const navigate                  = useNavigate();
    const [ready, setReady]         = useState<Boolean>();
    const [units, setUnits]         = useState<any>([]);
    const [groups, setGroups]       = useState<any>([]);
    const [providers, setProviders] = useState<any>([]);
    const [search, setSearch]       = useState('');
    const [page, setPage]           = useState<number>(1);
    const limit                     = 12;
    const [totalPages, setTotalPages] = useState<number>(1);
    const [hasNext, setHasNext]     = useState<boolean>(false);
    const [hasPrev, setHasPrev]     = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    // Local Editions

    // Context
    const {user}     = useContext(GeneralContext);
    const Modal      = useContext(ModalContext);
    const Units      = useContext(UnitsContext);

    function onChangeSearch (event: any) {
        let data = event.target.value;

        setSearch(data);
        setPage(1);
    }

    function openModal(modal: any, data?: any) {
        Modal.setModalOpen(false);
        Modal.setModalClass('munits');

        switch (modal) {
            case 'addClient':
                Modal.setModalTitle('Adicionando Unidade Consumidora')
                Modal.setModalBody(<FormUnit unit={null} groups={groups} providers={providers} setReady={setReady} />);
                Modal.setModalOpen(true)
                break;

            case 'infoMeasurement':
                Modal.setModalClass('no-flex-start minfoMeasurement')
                Modal.setModalTitle(`Medições - ${data?.name || 'Unidade'}`)
                Modal.setModalBody(<InfoMeasurement unit={data} />)
                Modal.setModalOpen(true)
                break;

            case 'editClient':
                Modal.setModalTitle('Editando Unidade Consumidora')
                Modal.setModalBody(<FormUnit unit={data} groups={groups} providers={providers} setReady={setReady} />);
                Modal.setModalOpen(true)
                break;

            case 'deleteClient':
                Modal.setModalClass('delete')
                Modal.setModalTitle('Excluindo Unidade Consumidora')
                Modal.setModalBody(<>
                    <div>Deseja realmente excluir a unidade consumidora <i>"{ data?.name }"?</i></div>
                    <div className="alert">* Tenha cuidado, esse processo é irreversível!</div>

                    <footer>
                        <button id="btnDelete" type="button" onClick={() => Units.remove(data.id, Modal, setReady)}>Excluir</button>
                        <button id="btnCancel" type="button" onClick={() => Modal.setModalOpen(false)}>Cancelar</button>
                    </footer>
                </>)
                Modal.setModalOpen(true)
                break;

            case 'energiesClient':
                Modal.setModalClass('menergies')
                Modal.setModalTitle('Editando Tipo de Energia')
                Modal.setModalBody(
                    <FormEnergies
                        unit={data?.id}
                        energies={Array.isArray(data?.energies) ? data.energies : []}
                        setReady={setReady}
                    />
                )
                Modal.setModalOpen(true)
                break;

            case 'pricesClient':
                Modal.setModalClass('mprices')
                Modal.setModalTitle('Preços')
                Modal.setModalBody(<FormPrices unit={data} setReady={setReady} />)
                Modal.setModalOpen(true)
                break;

            case 'othersValues':
                Modal.setModalClass('movalues')
                Modal.setModalTitle('Editando Outros Valores')
                Modal.setModalBody(<FormOthersValues unit={data.id} others={data.others} setReady={setReady} />)
                Modal.setModalOpen(true)
                break;


            case 'teAcl':
                Modal.setModalClass('mteAcl')
                Modal.setModalTitle('Adicionando valore da TE ACL')
                Modal.setModalBody(<FormTeAcl unit={data.id} teAcl={[]} setReady={setReady} />)
                Modal.setModalOpen(true)
                break;

            default:
                Modal.setModalClass(null)
                Modal.setModalTitle('')
                Modal.setModalBody(<></>)
                break;
        }
    }

    useEffect(() => {
        // Check Permission
        if (user.role==='client') navigate('/404', {replace: true})
        else {
            setIsLoading(true);
            api.get('clients/list', {
                headers: { Authorization: user.token },
                params: {
                    page,
                    limit,
                    ...(search ? { search } : {})
                }
            }).then(resp => {
                const pagination = resp?.data?.clients?.pagination || {};
                setUnits(resp?.data?.clients?.data || []);
                setGroups(resp?.data?.groups || []);
                setProviders(resp?.data?.providers || []);
                setTotalPages(pagination?.totalPages || 1);
                setHasNext(!!pagination?.hasNext);
                setHasPrev(!!pagination?.hasPrev);
                setReady(true);
            }).catch(() => {
                // keep units empty on error
            }).finally(() => {
                setIsLoading(false);
            });
        }
    }, [user, page, limit, search, navigate, ready]);

    return <Admin pageTitle="Gerenciamento de Unidades Consumidoras - Clientes Serena" title="Gerenciamento"  subtitle="Unidades Consumidoras dos Clientes" classMain='adm_units'>
        <div className="unitsContent">
            <div className="header">
                <div className="buttons">
                    <button
                        type="button"
                        className="addClient"
                        onClick={() => openModal('addClient')}
                        data-for="tooltip_units_page"
                        data-tip="Adicionar Unidade"
                    >
                        <FiPlus size="16" />
                    </button>
                </div>

                <div className='searchBox'>
                    <input
                        name="search" id="search"
                        type="text" autoComplete='false'
                        placeholder='Nome da unidade, Grupo ou Estado...'
                        value={search} onChange={onChangeSearch}
                    />

                    <div className={`btn${search !=='' ? ' lnk' : ''}`} onClick={() => {
                        if (search !== '') {
                            setPage(1)
                            setSearch('')
                        }
                    }}>
                        { search !=='' ? <FaTimes /> : <FaSearch /> }
                    </div>
                </div>
            </div>

            {isLoading ? (
                <LoadingSingle />
            ) : (
                <div className="units">
                    {
                        units.map((client: any) => (
                            <UnitsBox
                                key         = {`unit_${client.id}`}
                                {...client}
                                edit        = {() => openModal('editClient', client)}
                                measurements= {() => openModal('infoMeasurement', client)}
                                energies    = {() => openModal('energiesClient', client)}
                                prices      = {() => openModal('pricesClient', client)}
                                others      = {() => openModal('othersValues', client)}
                                teACL       = {() => openModal('teAcl', client)}
                                //pisCofins   = {() => openModal('pisCofins', client)}
                                delete      = {() => openModal('deleteClient', client)}
                            />
                        ))
                    }
                </div>
            )}
        </div>

        {!isLoading && (
            <div className="pagination">
                <button onClick={() => hasPrev && setPage(page - 1)} disabled={!hasPrev}><MdOutlineNavigateBefore /></button>
                <span>Página {page} de {totalPages}</span>
                <button onClick={() => hasNext && setPage(page + 1)} disabled={!hasNext}><MdOutlineNavigateNext /></button>
            </div>
        )}

        <ReactTooltip
            id="tooltip_units_page"
            place="top"
            effect="solid"
            type="info"
        />
    </Admin>
}

export default AdminUnits;